<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des bons de commandes fournisseurs</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
  </div>
    <div class="card-body p-15 p-sm-20 p-md-25">

      <div class="col-md-12">
        <div class="row">
         <!-- <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot clé
              </label>
              <Field style="max-height: 42px;" v-model="searchTerm" name="mot" type="text" aria-disabled="true"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
            </div>
          </div>-->
          <div class="col-md-4" v-if="point_ventes.length > 1">
    <div class="form-group mb-15 mb-sm-20 mb-md-25">
      <label class="d-block text-black fw-semibold mb-10">
       Filtrer par Point de vente
      </label>
      <div class="d-flex align-items-center" style="width: 200px;">
        <Multiselect 
         
          v-model="point_vente" 
          :options="point_ventes"  
          :searchable="true" 
          track-by="label" 
          label="label" 
          placeholder="Sélectionner un point de vente" 
        />
      </div>
    </div>
  </div>
         <!-- <div class="col-md-4">
            <div class="form-group ">
              <label class="d-block text-black fw-semibold mb-10">
                Type Operation
              </label>
              <Multiselect :searchable="true" :options="lestypes" v-model="_type" placeholder="Choisir" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Motif d'Opération
              </label>
              <Multiselect v-model="_motif" :options="motifSuiviOptions" :searchable="true"
                placeholder="Sélectionner le motif" />
            </div>
          </div>-->
        </div>
      </div>
      <hr>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Image
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date Com Four.
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Ref. Doc.
              </th>
              <!--<th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Type Opér.
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Motif
              </th>-->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Fournisseur
              </th>
             <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>-->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(commandefournisseurs, index) in commandefournisseurs" :key="index">
              
              <td>
                <ModalImage v-if="commandefournisseurs" :libelle="commandefournisseurs.refDoc" :keyValue="commandefournisseurs.id" :fileUrl="commandefournisseurs.imageBon"/>  
              </td> 
              <td class="shadow-none lh-1 fw-medium ">
                {{ format_date(commandefournisseurs?.dateOperation) }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ commandefournisseurs.refDoc }}
              </td>
              <!--<td class="shadow-none lh-1 fw-medium ">
                {{ commandefournisseurs?.typeOperation }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ commandefournisseurs?.motifSuivi?.libelle }}
              </td>-->
              <td class="shadow-none lh-1 fw-medium ">
                {{ commandefournisseurs?.fournisseur.nomFournisseur }} {{ commandefournisseurs?.fournisseur.prenomFournisseur}} {{ commandefournisseurs?.fournisseur.denomination}}
              </td>
              <!--<td class="shadow-none lh-1 fw-medium ">
                <div v-if="commandefournisseurs.statut === 0">
                  <span class="badge badge-primary">En cours</span>
                </div>
                <div v-if="commandefournisseurs.statut === 1">
                  <span class="badge badge-success">Valider</span>
                </div>
              </td>-->
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <button class="btn dropdown-toggle btn-primary text-black" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">Actions</button>
                  <ul class="dropdown-menu">
                    <li class="dropdown-item d-flex align-items-center" v-if="checkPermission('ViewBonCommandeFournisseur')">
                      <router-link :to="{ name: 'ViewBonCommandeFournisseur', params: { id: commandefournisseurs.id } }"
                        class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                      </router-link>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from "@/services/ApiService";
import { useRouter } from 'vue-router';
import { format_date, suppression, format_Date, separateur, error, success, getUrlApiForProductFiles } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import Swal from "sweetalert2";
import axios from "axios";
import ModalImage from "@/components/GesCom/Produit/ModalImage.vue"


export default defineComponent({
  name: "ListeMouvementFiche",
  components: {
    Form,
    Field,
    Multiselect,
    PaginationComponent,
    ModalImage,
  },
  setup: () => {
    const commandefournisseurs = ref<Array<any>>([]);
    const produitOptions = ref([]);
    const magasinOptions = ref([]);
    const magasin = ref([]);
    const produit = ref([]);
    const selectedEtat = ref('');
    const prodEtat = ref(true);

    // BEGIN PAGINATE

    const _type = ref('');
    const _motif = ref('');
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const router = useRouter();

    let point_vente = ref<string>("");
    let point_ventes = ref([]);


    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllBonlivraisons(page_, limit_);
      } catch (error) {
        //
      }
    };
    const motifSuiviOptions = ref([])

    const fetchMotifSuivi = async () => {
      try {
        const response = await ApiService.get("/all/motifSuivis");
        const invData = response.data.data.data;
        motifSuiviOptions.value = invData.map((inv) => ({
          value: inv.id,
          label: `${inv.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const lestypes = ref([
      { value: "Entrée", label: "Entrée" },
      { value: "Sortie", label: "Sortie" }
    ]);


    watch(_type, () => {
      rechercher();
    });

    watch(_motif, () => {
      rechercher();
    });

    watch(searchTerm, () => {
      rechercher();
    });

    watch(selectedEtat, () => {
      if (selectedEtat.value == 'Tout')
        selectedEtat.value = '';
      rechercher();
    });

    watch(point_vente, () => {
      rechercher();
    });

    function rechercher() {
      getAllBonlivraisons(point_vente.value, page.value, limit.value, searchTerm.value, _motif.value, selectedEtat.value, _type.value);
    }


    const recharger = () => {
      getAllBonlivraisons(point_vente.value);
    };

    function getAllBonlivraisons(point_vent, page = 1, limi = 10, searchTerm = '', _motif = '', selectedEtat = '', type = "") {
      return axios.get(`/all/boncomfournisseurs?page=${page}&limit=${limi}&mot=${searchTerm}&motif=${_motif}&etat=${selectedEtat}&type=${type}&pointvente=${point_vent}&`)
        .then(({ data }) => {
          commandefournisseurs.value = data.data.data
          console.log("MOOOOOOOOOUUUUUUUUUVE ===>", commandefournisseurs.value);
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          // error(response.data.message);
        });
    }

    const valider = async (id: any) => {
      Swal.fire({
        text: `Vous êtes sur le point de valider le commandefournisseurs n°${id}.\n Etes-vous sûr ?`,
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Valider",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger"
        },
      }).then(async (result) => {
        try {
          if (result.isConfirmed) {
            const response = await ApiService.put("/mouvementfiches/statut/" + id, {})
            if (response.data.code == 200) {
              rechercher();
              success(response.data.message);
              router.push({ name: "ListeMouvementFiche" });
            }
          } else {
            error("Vous avez annulé la soumission");
          }

        } catch (response) {
          error(response.message);
        }
      })
    }

    onMounted(async() => {
      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
        value: point.id,
        label: point.nomPointVente
      })) : [];
      getAllBonlivraisons( point_vente.value);
      fetchMotifSuivi();
    });



    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return {
      commandefournisseurs,
      checkPermission,
      produitOptions,
      magasinOptions,
      format_date,
      suppression,
      getAllBonlivraisons,
      page,
      totalPages,
      limit,
      format_Date,
      totalElements,
      handlePaginate,
      valider,
      _type,
      _motif,
      lestypes,
      separateur,
      searchTerm,
      prodEtat,
      magasin, produit,
      rechercher,
      motifSuiviOptions,
      selectedEtat,
      getUrlApiForProductFiles,
      recharger,
      point_ventes,
      point_vente
    };
  },
});
</script>